import React, { useEffect, useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { useQuery } from "@apollo/client";
import EligibilityResponseModal from "./components/EligibilityResponseModal";
import eligibility from "../../gql/eligibility";
import DownloadExcel from "../../components/DownloadExcel";
import Pagination from "../../components/Pagination";
import FilterModal from "./components/requestEligibility/FilterModal";
import RequestEligibilityModal from "./components/requestEligibility/RequestEligibilityModal";
import TableLoader from "../../common/TableLoader";
import "./styles/eligibility.css";
import "../Beneficiary/styles/BeneficiaryList.css";
import { Chip, Tooltip } from "@mui/material";
import EligibilityJsonViewModal from "./EligibilityJsonViewModal";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { BsFiletypeJson } from "react-icons/bs";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { useTranslation } from "react-i18next";
import TableSkeletonLoader from "../../common/TableLoading";
import AppButton from "../../shared/AppButton";
import AppTable from "../../shared/AppTable";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RequestEligibilityDialog from "./components/requestEligibility/RequestEligibilityDialog";
import { FaFilter } from "react-icons/fa";

function EligibilityList(props) {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [errorData, setErrorData] = useState([]);
  const [eligibilityLoading, setEligibilityLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(true);
  const [openEligibilityDialog, setOpenEligibilityDialog] = useState(false);

  const [excelData, setExcelData] = useState([
    { id: 1, name: "John Doe", email: "john.doe@example.com" },
    { id: 2, name: "Jane Doe", email: "jane.doe@example.com" },
    { id: 3, name: "Bob Smith", email: "bob.smith@example.com" },
  ]);

  const currentDate = new Date();

  const fromDate = `${currentDate.getFullYear()}-${String(
    currentDate.getMonth() + 1,
  ).padStart(2, "0")}-01`;
  const toDate = `${currentDate.getFullYear()}-${String(
    currentDate.getMonth() + 1,
  ).padStart(2, "0")}-${new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    0,
  ).getDate()}`;

  const [open, setOpen] = useState(false);
  const [selectedItem, setSeelectedItem] = useState(null);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const [filterDate, setFilterDate] = useState({
    from: fromDate,
    to: toDate,
  });

  const [item, setItem] = useState({});
  const [showEligibilityModal, setShowEligibilityModal] = useState(false);
  const [showEligibilityResponseModal, setShowEligibilityResponseModal] =
    useState(false);
  const preFilters = localStorage.getItem("eligibilityFilterDate")
    ? JSON.parse(localStorage.getItem("eligibilityFilterDate"))
    : null;

  const initialFilters = {
    from_date: fromDate,
    to_date: toDate,
    // eligibility_id: "",
    payer_id: "",
    patient_name: "",
    status: "",
    page: 1,
    limit: 15,
  };

  const [eligibilityFilters, setEligibilityFilters] = useState(
    preFilters ? preFilters : initialFilters,
  );

  const { loading, error, data, refetch } = useQuery(
    eligibility.GET_ELIGIBILITY_TRANSACTIONS,
    {
      variables: {
        input: {
          ...Object.keys(eligibilityFilters).reduce((acc, key) => {
            const value = eligibilityFilters[key];
            if (value !== "" && value !== null) {
              acc[key] = value;
            }
            return acc;
          }, {}),
        },
      },
      fetchPolicy: "no-cache",
    },
  );

  const {
    loading: excelDataLoading,
    error: excelDataError,
    data: excelDataResponse,
    refetch: refetchExcelDataResponse,
  } = useQuery(eligibility.GET_TRANSACTIONS_IN_EXCEL, {
    variables: {
      input: {
        from_date: currentDate.toISOString().substring(0, 10),
        to_date: currentDate.toISOString().substring(0, 10),
      },
    },
    skip: true,
  });

  useEffect(() => {
    if (excelDataResponse) {
      setExcelData(
        JSON.parse(excelDataResponse?.listVerificationTransactionsExcel?.data),
      );
    }
  }, [excelDataResponse]);

  const onPageChange = async (currentPage) => {
    const removeEmptyKeys = (obj) => {
      const newObj = {};
      for (const key in obj) {
        if (obj[key] !== "") {
          newObj[key] = obj[key];
        }
      }
      return newObj;
    };
    const filteredEligibilityFilterDate = removeEmptyKeys(eligibilityFilters);
    let filterInput = {
      ...filteredEligibilityFilterDate,
      page: currentPage,
    };
    refetch({
      input: filterInput,
    });
    setEligibilityFilters((prev) => {
      const newFilters = {
        ...prev,
        page: currentPage,
      };
      localStorage.setItem("eligibilityFilterDate", JSON.stringify(newFilters));
      return newFilters;
    });
  };

  const onDataRowClicked = (eligibilityItem) => {
    navigate("/eligibility/details", { state: { item: eligibilityItem } });
  };

  const formatDateTime = (time) => {
    const dateTime = new Date(time);
    const dateOnly = dateTime.toLocaleDateString("en-GB");
    const timeOnly = dateTime.toLocaleTimeString(navigator.language, {
      hour: "2-digit",
      minute: "2-digit",
    });
    return `${dateOnly} <br/> ${timeOnly}`;
  };

  const tooltipText = (el) => {
    if (el?.site_eligibility === "eligible") {
      return "Eligible";
    } else if (el?.site_eligibility === "not-active") {
      return "Member's insurance policy is not active";
    } else if (el?.site_eligibility === "not-covered") {
      return "Policy does not cover the requested services";
    } else if (el?.site_eligibility === "not-direct-billing") {
      return "Patient is not covered on direct billing basis";
    } else if (el?.site_eligibility === "out-network") {
      return "Provider outside member Network";
    } else if (el?.site_eligibility === "limit-exhausted") {
      return "Patient policy/benefit limit is exhausted";
    } else if (el?.site_eligibility === "coverage-suspended") {
      return "Patient coverage is suspended";
    } else if (el?.site_eligibility === "provider-contract-suspended") {
      return "Provider contract is suspended";
    } else {
      // Default case
      return "Unknown eligibility status";
    }
  };

  const getStatusStyles = (status) => {
    const s = status?.toLowerCase();
    if (s === "eligible" || s === "complete" || s === "success") {
      return { bg: "#dcfce7", text: "#15803d" };
    } else if (s === "error" || s === "not-active") {
      return { bg: "#fee2e2", text: "#b91c1c" };
    } else if (s === "out-network" || s === "primary") {
      return { bg: "#dbeafe", text: "#1d4ed8" };
    } else {
      return { bg: "#f1f5f9", text: "#475569" };
    }
  };

  const columns = [
    {
      header: t("SQ #"),
      render: (row, index) =>
        eligibilityFilters?.page * eligibilityFilters?.limit +
        index +
        1 -
        eligibilityFilters?.limit,
    },
    // {
    //   header: t("Status"),
    //   render: (row) => {
    //     if (!row?.status) return "---";
    //     const styles = getStatusStyles(row?.status);
    //     return (
    //       <Chip
    //         label={row?.status}
    //         size="small"
    //         sx={{
    //           backgroundColor: styles.bg,
    //           color: styles.text,
    //           fontWeight: "700",
    //           fontSize: "10px",
    //           borderRadius: "6px",
    //           textTransform: "uppercase",
    //           height: 20,
    //         }}
    //       />
    //     );
    //   },
    // },
    {
      header: t("Site Eligibility"),
      render: (row) => {
        if (!row?.site_eligibility) return "---";
        const styles = getStatusStyles(row?.site_eligibility);
        return (
          <Tooltip title={tooltipText(row)}>
            <Chip
              label={row?.site_eligibility}
              size="small"
              sx={{
                backgroundColor: styles.bg,
                color: styles.text,
                fontWeight: "700",
                fontSize: "10px",
                borderRadius: "6px",
                textTransform: "uppercase",
                height: 20,
                border: `1px solid ${styles.text}20`,
              }}
            />
          </Tooltip>
        );
      },
    },
    {
      header: t("Transaction Date"),
      render: (row) => (
        <span
          dangerouslySetInnerHTML={{
            __html: formatDateTime(row?.transaction_date),
          }}
        />
      ),
    },
    {
      header: t("Beneficiary Name"),
      render: (row) => (
        <span className="capitalize font-medium text-gray-700 whitespace-nowrap">
          {row?.patient_name || "---"}
        </span>
      ),
    },
    { header: t("Purpose"), field: "purpose" },
    {
      header: t("Payer"),
      render: (row) => (
        <span className="text-[12px] text-gray-700 w-[250px] block whitespace-pre-wrap">
          {row?.payer_name || "---"}
        </span>
      ),
    },
  ];

  const downloadExcelFile = (fileName) => {
    refetchExcelDataResponse({
      input: {
        // limit: limit,
        // page: pageNo,
        from_date: eligibilityFilters?.from_date,
        to_date: eligibilityFilters?.to_date,
      },
    }).then((res) => {
      const data = JSON.parse(
        res?.data?.listVerificationTransactionsExcel?.data,
      );
      const workbook = XLSX.utils.book_new();
      const sheet = XLSX.utils.json_to_sheet(data);
      XLSX.utils.book_append_sheet(workbook, sheet, "Sheet1");
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const fileData = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(fileData, `${fileName}.xlsx`);
    });
  };

  return (
    <>
      {/* {loading || excelDataLoading || eligibilityLoading ? <TableSkeletonLoader/> : ()
       } */}
      <div class="eligibility_container">
        <div class="">
          <div className="flex justify-between flex-col sm:flex-row gap-2 mb-2">
            <div className="w-full sm:w-[calc(100%-150px)]">
              <span className="font-semibold text-black/70 text-lg ">
                {t("Eligibility Transactions")}
                <span className=" text-lg ml-1">
                  ({data?.listVerificationTransactions?.total || 0}{" "}
                  <span className="text-xs font-bold italic">
                    {t("Entries")}
                  </span>
                  )
                </span>
              </span>
            </div>
            <div className="w-full flex flex-col sm:flex-row gap-2  justify-end">
              <AppButton

                label={t("Create Beneficary")}
                onClick={() => navigate("/beneficiary/form")}
                startIcon={<AddIcon />}
              />
              <AppButton
                label={t("Request Eligibility")}
                onClick={() => setOpenEligibilityDialog(true)}
                startIcon={<AddIcon />}
              />
            </div>
          </div>
        </div>

        <div class="bg-white border border-slate-200 rounded-lg p-2 mb-2">
          <FilterModal
            eligibilityFilters={eligibilityFilters}
            setEligibilityFilters={setEligibilityFilters}
            refetch={refetch}
            fromDate={fromDate}
            toDate={toDate}
            setIsLoading={setIsLoading}
          />
        </div>

        <Dialog
          open={openEligibilityDialog}
          onClose={() => setOpenEligibilityDialog(false)}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              maxWidth: "950px",
              width: "100%",
            },
          }}
        >
          <DialogTitle
            sx={{
              p: "8px 16px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            className="flex justify-between items-center"
          >
            <span className="font-bold">{t("Request Eligibility")}</span>
            <IconButton onClick={() => setOpenEligibilityDialog(false)}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent
            dividers
            sx={{
              p: 1.5,
              "& .MuiGrid-root": { mt: 0 },
            }}
          >
            <RequestEligibilityDialog
              errorData={errorData}
              setErrorData={setErrorData}
              fromDate={fromDate}
              toDate={toDate}
              refetch={refetch}
              onClose={() => setOpenEligibilityDialog(false)}
            />
          </DialogContent>
        </Dialog>

        <div className="mt-2">
          <AppTable
          cellClassName="!py-0"
            columns={columns}
            data={data?.listVerificationTransactions?.data}
            loading={loading || isLoading}
            onView={onDataRowClicked}
            onJsonView={(row) => {
              setSeelectedItem(row);
              handleClickOpen();
            }}
            onPreAuth={(row) =>
              navigate("/preauth/form", {
                state: { patient_name: row?.patient_name },
              })
            }
            LoaderComponent={
              <TableSkeletonLoader columnCount={8} rowCount={6} />
            }
          />
        </div>

        {/* 
<div class="eligibility-page">
          <div className="flex justify-between flex-col lg:flex-row gap-4 mb-2 ">
            {/+ <div className=''>
              <Tooltip
                placement='right'
                title={t('Keep track of your Eligibility Transactions')}
                className='my-auto !mt-2'
              >
                <span className='font-semibold text-black/70 text-lg '>
                  {t('Eligibility Transactions')}
                  <span className='italic text-lg ml-1'>
                    ({data?.listVerificationTransactions?.total || 0}{' '}
                    <span className='text-xs font-bold italic'>
                      {t('Entries')}
                    </span>
                    )
                  </span>
                </span>
              </Tooltip>
            </div> +/}
            <div className="flex w-full gap-1.5 flex-col md:flex-row justify-end">
              {/+ <Button
                variant="outlined"
                size="small"
                onClick={() => downloadExcelFile("Eligibilities")}
                className="!border-primary !text-primary hover:!bg-primary/10"
                startIcon={<FileDownloadOutlinedIcon />}
              >
                {t("Download")}
              </Button> +/}
              <AppButton
                variant="outlined"
                onClick={() => downloadExcelFile("Eligibilities")}
                startIcon={<FileDownloadOutlinedIcon />}
              >
                {t("Download")}
              </AppButton>
              {/+ <Button
                variant="contained"
                size="small"
                onClick={() => navigate("/beneficiary/form")}
                style={{
                  backgroundImage:
                    "linear-gradient(83deg, #f14f3e 25%, #0070C2 100%)",
                }}
                startIcon={<AddIcon />}
              >
                {t("Create Beneficary")}
              </Button> +/}
              <AppButton
                onClick={() => navigate("/beneficiary/form")}
                startIcon={<AddIcon />}
              >
                {t("Create Beneficary")}
              </AppButton>
              {/+ <Button
                variant="contained"
                size="small"
                onClick={() => setShowEligibilityModal(true)}
                style={{
                  backgroundImage:
                    "linear-gradient(83deg, #f14f3e 25%, #0070C2 100%)",
                }}
                startIcon={<AddIcon />}
              >
                {t("Request Eligibility")}
              </Button> +/}
              <AppButton
                onClick={() => setShowEligibilityModal(true)}
                startIcon={<AddIcon />}
              >
                {t("Request Eligibility")}
              </AppButton>
            </div>
            <RequestEligibilityModal
              showEligibilityModal={showEligibilityModal}
              setShowEligibilityModal={setShowEligibilityModal}
              errorData={errorData}
              setErrorData={setErrorData}
              refetch={refetch}
              fromDate={fromDate}
              toDate={toDate}
            />
          </div>
        </div>

        <div class="bg-white border border-slate-200 rounded-lg p-2 mb-2">
          <FilterModal
            eligibilityFilters={eligibilityFilters}
            setEligibilityFilters={setEligibilityFilters}
            refetch={refetch}
            fromDate={fromDate}
            toDate={toDate}
            setIsLoading={setIsLoading}
          />
        </div>

        <div className="super-git-table !p-0 !m-0">
          <table className="table-super-git !p-0">
            <thead className="!p-0">
              <tr className="!p-0">
                {tableHeaders.map((el, index) => {
                  return (
                    <th className="!p-2 !text-sm" key={"tableHeaders_" + index}>
                      {el.name}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {loading ||
              excelDataLoading ||
              eligibilityLoading ||
              isLoading ? (
                <TableSkeletonLoader
                  columnCount={tableHeaders?.length}
                  rowCount={6}
                />
              ) : data?.listVerificationTransactions?.data?.length > 0 ? (
                data?.listVerificationTransactions?.data?.map((el, index) => {
                  return (
                    <tr
                      className="!p-0"
                      key={"eligibilitiesData_" + index}
                      onClick={() => setSeelectedItem(el)}
                    >
                      {/+ 1 +/}
                      <td className="!p-1 !text-sm">
                        {eligibilityFilters?.page * eligibilityFilters?.limit +
                          index +
                          1 -
                          eligibilityFilters?.limit}
                      </td>

                      {/+ 2 +/}
                      <td className="!p-1 !text-sm">
                        {formatDateTime(el?.transaction_date)}
                      </td>

                      {/+ 3 +/}
                      <td className="!p-0 capitalize text-start !text-sm">
                        {el?.patient_name.length > 100 ? (
                          <Tooltip title={el?.patient_name}>
                            <span>{el?.patient_name.slice(0, 100)}...</span>
                          </Tooltip>
                        ) : (
                          el?.patient_name
                        )}
                      </td>

                      {/+ 4 +/}
                      <td className="!p-1 !text-sm">{el?.purpose}</td>

                      {/+ 5 +/}
                      <td className="!p-1 capitalize !text-sm">
                        {el?.payer_name.length > 100 ? (
                          <Tooltip title={el?.payer_name}>
                            <span>{el?.payer_name.slice(0, 100)}...</span>
                          </Tooltip>
                        ) : (
                          el?.payer_name
                        )}
                      </td>

                      <td className="!p-1 !text-sm">{el?.verification_id}</td>

                      {/+ 6 +/}
                      <td
                        className="!p-1 capitalize !text-sm"
                        data-toggle="tooltip"
                        data-placement="top"
                        title={tooltipText(el)}
                      >
                        {el?.site_eligibility ? (
                          <Chip
                            label={el?.site_eligibility}
                            color={getColor(el?.site_eligibility)}
                            size="small"
                            className="uppercase !text-xs "
                          />
                        ) : (
                          ""
                        )}
                      </td>

                      {/+ 7 +/}
                      <td className="!p-1 capitalize !text-sm">
                        {el?.status ? (
                          <Chip
                            label={el?.status}
                            color={getColor(el?.status)}
                            size="small"
                            className="uppercase !text-xs "
                          />
                        ) : (
                          ""
                        )}
                      </td>

                      {/+ 8 +/}
                      <td className="user-action flex gap-2 justify-end items-center h-full mx-2  !p-1">
                        <Tooltip title={t("View")}>
                          <div
                            onClick={() => onDataRowClicked(el)}
                            className="text-xl cursor-pointer"
                          >
                            <MdOutlineRemoveRedEye />
                          </div>
                        </Tooltip>
                        <Tooltip title={t("JSON View")}>
                          <div
                            onClick={handleClickOpen}
                            className="text-xl cursor-pointer"
                          >
                            <BsFiletypeJson />
                          </div>
                        </Tooltip>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={tableHeaders.length + 2}>
                    <div className="flex justify-center">
                      <h2 className="text-center text-lg">
                        {t("No Data Found")}
                      </h2>
                    </div>
                  </td>
                </tr>
              )}
              {}
            </tbody>
          </table>
        </div>
 */}

        <div>
          <Pagination
            currentPage={eligibilityFilters?.page}
            totalPages={data?.listVerificationTransactions?.pages}
            onPageChange={onPageChange}
          />
        </div>
        <EligibilityResponseModal
          showEligibilityResponseModal={showEligibilityResponseModal}
          setShowEligibilityResponseModal={setShowEligibilityResponseModal}
          item={item}
        />
        <EligibilityJsonViewModal
          setOpen={setOpen}
          open={open}
          handleClose={handleClose}
          selectedItem={selectedItem}
        />
      </div>
    </>
  );
}

export default EligibilityList;
